import dsbridge from 'dsbridge';

class DSBridge {
  private handlers: { [key: string]: (data: any, responseCallback: (response: any) => void) => void } = {};

  constructor() {
  }

  callNative(method: string, params?: any, callback?: (result: any) => void): void {
    dsbridge.call(method, params, (response: any) => {
      if (callback) {
        callback(response);
      }
    });
  }

  registerHandler(method: string, handler: (data: any, responseCallback: (response: any) => void) => void): void {
    dsbridge.register(method, handler);
  }

  registerAsync(method: string, handler: (data: any) => Promise<any>): void {
    dsbridge.registerAsyn(method, (data: any, responseCallback: (response: any) => void) => {
      handler(data)
        .then(response => responseCallback(response))
        .catch(error => responseCallback({ error }));
    });
  }

  isDSBridgeEnvironment() {
    // 方法1: 检查全局对象
    if (import.meta.env.VITE_APP_NAME == 'chatapp') {
      return true
    }
    return false
  }
}

export default new DSBridge();